import { BrandLogo } from '@cube3/cubicle/src/core/atoms/BrandLogo/BrandLogo';
import { Checkbox } from '@cube3/cubicle/src/core/atoms/Checkbox/Checkbox';
import { Typography } from '@cube3/cubicle/src/core/atoms/Typography';
import { HBox, VBox } from '@cube3/cubicle/src/core/templates/layout/Flex';
import { SizeVariants } from '@cube3/cubicle/src/theme/themes';
import { makeCSS } from '@cube3/cubicle/src/utils/makeCSS';
import React, { LegacyRef } from 'react';

export const usePrintRecoveryCodesCSS = makeCSS(({ theme }) => ({
  root: {
    padding: theme.spacing[10]
  },
  title: {
    padding: `${theme.spacing[4]} 0px`
  },
  codes: {
    display: 'grid',
    gridTemplateColumns: 'repeat(4, 1fr)',
    rowGap: 16
  },
  checkbox: {
    display: 'inline-block',
    width: theme.spacing[4],
    height: theme.spacing[4],
    border: '1px solid rgba(0,0,0,0.12)',
    background: 'rgba(0,0,0,0.04)',
    borderRadius: theme.borderRadius.md
  },
  code: {
    '& > *': {
      userSelect: 'all'
    }
  }
}));

type Props = {
  contentRef: LegacyRef<HTMLDivElement>;
  codes: string[];
};

export const RecoveryCodesToPrint = (props: Props) => {
  const { contentRef, codes } = props;

  const classes = usePrintRecoveryCodesCSS();
  return (
    <div ref={contentRef} className={classes.root}>
      <VBox gap={16}>
        <BrandLogo logo="cube_Black" size={SizeVariants['3xl']} />
        <div className={classes.title}>
          <Typography
            colorVariant="01"
            lineHeight="trim"
            weight="label"
            color="light"
          >
            Recovery codes
          </Typography>
        </div>
        <Typography colorVariant="03" color="light">
          Recovery codes can be used to access your account in the event you
          lose access to your device and cannot receive two-factor
          authentication codes. Recovery codes should be used in order.
        </Typography>

        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(4, 1fr)',
            rowGap: 16
          }}
        >
          {codes.map((code) => (
            <HBox key={code} gap={8} align="center" justify="start">
              <span className={classes.checkbox} />
              <Typography
                weight="body"
                color="light"
                colorVariant="02"
                variant={SizeVariants.md}
              >
                {code}
              </Typography>
            </HBox>
          ))}
        </div>
      </VBox>
    </div>
  );
};
